//iffe to pass to pass in jquery and ht namespace. THe following notation is to avoid namespace collision and run code immediately
(function($, ht){